import {call, put, takeLatest} from "redux-saga/effects";
import ApiUtil from "src/utils/ApiUtil";
import {
    FUTURE_FEE_CONFIG_QUERY_START,
    FutureFeeConfigQueryStartAction, getFutureFeeConfigFailedAction,
    getFutureFeeConfigSuccessAction
} from "src/actions/FutureFeeConfigQueryAction";
import {FutureFeeConfig} from "src/model/FutureFee";

export function* getFutureFeeConfig(action: FutureFeeConfigQueryStartAction) {
    try {
        const mockResponse = {
                               "futureFeeConfigMap": {
                                 "US": {
                                   "FulfillmentFee": [1716716800000, 1726716800000, 1734038400000],
                                   "ReferralFee": [1708716800000],
                                   "FBAStorageFee": [1709222500000],
                                   "FBAInboundConvenienceFee": [1708716800000]
                                 },
                                 "CA": {
                                   "FulfillmentFee": [1704038400000, 1706716800000],
                                   "ReferralFee": [1708716800000],
                                   "FBAInboundConvenienceFee": [1708716800000]
                                 }
                               },
                               "futureFeeConfigMapV2": {
                                 "US": {
                                   "FulfillmentFee": [
                                     {"login": "testuser", "date": 1716716800000, "beginToDisplayDate": 1716630400000},
                                     {"login": "testuser", "date": 1726716800000, "beginToDisplayDate": 1726630400000},
                                     {"login": "testuser", "date": 1734038400000, "beginToDisplayDate": 1733952000000}
                                   ],
                                   "ReferralFee": [
                                     {"login": "testuser", "date": 1708716800000, "beginToDisplayDate": 1708630400000}
                                   ],
                                   "FBAStorageFee": [
                                     {"login": "testuser", "date": 1709222500000, "beginToDisplayDate": 1709136100000}
                                   ],
                                   "FBAInboundConvenienceFee": [
                                     {"login": "testuser", "date": 1708716800000, "beginToDisplayDate": 1708630400000}
                                   ]
                                 },
                                 "CA": {
                                   "FulfillmentFee": [
                                     {"login": "testuser", "date": 1704038400000, "beginToDisplayDate": 1703952000000},
                                     {"login": "testuser", "date": 1706716800000, "beginToDisplayDate": 1706630400000}
                                   ],
                                   "ReferralFee": [
                                     {"login": "testuser", "date": 1708716800000, "beginToDisplayDate": 1708630400000}
                                   ],
                                   "FBAInboundConvenienceFee": [
                                     {"login": "testuser", "date": 1708716800000, "beginToDisplayDate": 1708630400000}
                                   ]
                                 }
                               }
                             };
        
        const response = mockResponse;
        const futureFeeConfigMap = new Map<string, Map<string, Array<number>>>();
        const futureFeeConfigMapV2 = new Map<string, Map<string, Array<any>>>();
        
        const responseMap = response.futureFeeConfigMap as any;
        for (const marketplace in responseMap) {
            const marketplaceData = responseMap[marketplace];
            const feeTypeMap = new Map<string, Array<number>>();

            for (const feeType in marketplaceData) {
                const feeTypeData = marketplaceData[feeType];
                feeTypeMap.set(feeType, feeTypeData);
            }

            futureFeeConfigMap.set(marketplace, feeTypeMap);
        }

        const responseMapV2 = response.futureFeeConfigMapV2 as any;
        for (const marketplace in responseMapV2) {
            const marketplaceData = responseMapV2[marketplace];
            const feeTypeMap = new Map<string, Array<any>>();

            for (const feeType in marketplaceData) {
                const feeTypeData = marketplaceData[feeType].map((entry: any) => ({
                    timestamp: entry.date,
                    displayTimestamp: entry.beginToDisplayDate,
                    login: entry.login
                }));
                feeTypeMap.set(feeType, feeTypeData);
            }

            futureFeeConfigMapV2.set(marketplace, feeTypeMap);
        }

        const futureFeeConfig: FutureFeeConfig = {
            futureFeeConfigMap: futureFeeConfigMap,
            futureFeeConfigMapV2: futureFeeConfigMapV2,
        };

        yield put(getFutureFeeConfigSuccessAction(futureFeeConfig));
    } catch (error) {
        yield put(getFutureFeeConfigFailedAction());
        return;
    }
}

export default function* futureFeeConfigQuery() {
    yield takeLatest(FUTURE_FEE_CONFIG_QUERY_START, getFutureFeeConfig);
}